<template>
  <div class="container">
    <b-card>
    <div class="d-flex align-items-center">
      <h2 class="mb-0">Blacklist</h2>

      <b-button
        variant="link"
        class="p-0 ml-2 text-muted"
        @click="openManual"
      >
        <i 
        class="fas fa-question-circle fa-lg" 
        v-b-tooltip.hover  
        title="Acesse o manual desta página no Wiki"
        style="cursor: pointer;">
        </i>
      </b-button>
    </div>

    <div v-if="isLoading" class="text-center my-4">
      <b-spinner variant="primary" label="Carregando"></b-spinner>
    </div>

    <div v-else>
      <div class="d-flex justify-content-between mt-2 align-items-center">
        <div class="w-50">
          <b-input-group>
            <b-form-input
              v-model="search"
              @keyup.enter="handleSearch"
              placeholder="CNPJ/Razão Social a ser consultado"
            />
            <b-input-group-append>
              <b-button 
                variant="primary" 
                @click="handleSearch"
                :disabled="searchLoading"
              >
                <b-spinner small v-if="searchLoading"></b-spinner>
                <i v-else class="fas fa-search"></i>
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
       <div v-if="bulkLoading" class="d-flex align-items-center ml-3">
          <b-spinner small variant="primary"></b-spinner>
          <span class="ml-2">Processando arquivo...</span>
        </div>
      </div>
      </div>
    </b-card>

    <BlacklistStats 
     :header="header"
     :canManage="hasActionPermission"
      @open-add-modal="showAddModal = true" 
      @open-bulk-modal="showBulkModal = true"
      @open-delete-modal="showDeleteModal = true"
      />

    <BlacklistHistory  
      v-if="hasHistoryPermission"
     :history="history" 
     />

    <AddBlacklistModal
      :show="showAddModal"
      @close="showAddModal = false"
      @submit="handleAdd"
    />

    <BulkUploadModal
      :show="showBulkModal"
      :loading="bulkLoading"
      @close="showBulkModal = false"
      @submit="handleBulkUpload"
    />

    <DeleteBlacklistModal
      :show="showDeleteModal"
      @close="showDeleteModal = false"
      @submit="handleDelete"
    />

    <BlacklistResultModal
      :show="showResultModal"
      :data="blacklistResult"
      :notFound="notFound"
      @close="showResultModal = false"
    />

    <BulkResultModal
      :show="showBulkResultModal"
      :data="bulkResult"
      @close="showBulkResultModal = false"
    />
  </div>
</template>

<script>
import { BCard, BButton, BInputGroup,BInputGroupAppend, BFormInput, BSpinner} from "bootstrap-vue";
import BlacklistStats from "./BlacklistStats.vue";
import BlacklistHistory from "./BlacklistHistory.vue";
import AddBlacklistModal from "./components/AddBlacklistModal.vue";
import BulkUploadModal from './components/BulkUploadModal.vue'
import DeleteBlacklistModal from "./components/DeleteBlacklistModal.vue";
import BlacklistResultModal from "./components/BlacklistResultModal.vue";
import BulkResultModal from "./components/BulkResultModal.vue";
import BlacklistService from '@/service/blacklist'
import UserService from '@/service/user/user'
import permissions from '@/enums/permissions'



export default {
  components: {
    BCard,
    BSpinner,
    BButton,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    BlacklistStats,
    AddBlacklistModal,
    BlacklistHistory,
    BulkUploadModal,
    DeleteBlacklistModal,
    BlacklistResultModal,
    BulkResultModal
  },
  data() {
    return {
      search: '',
      showAddModal: false,
      showBulkModal: false,
      showDeleteModal: false,
      header: {},
      history: [],
      isLoading: false,
      blacklistResult: [],
      showResultModal: false,
      notFound: false,
      user: null,
      searchLoading: false,
      bulkLoading: false,
      bulkResult: {
        quantity_ok: 0,
        quantity_invalid: 0,
        invalid_data: []
      },
      showBulkResultModal: false
    }
  },

  async mounted() {
    this.fetchBlacklist()

    const response = await UserService.me()
    this.user = response.data.user
    
  },

  computed: {
    permissions() {
      return this.$store.state.user.data.profile.permissions || []
    },

    hasHistoryPermission() {
      return this.permissions.includes(permissions.blacklistViewHistory)
    },

    hasActionPermission() {
      return this.permissions.includes(permissions.blacklistManage)
    }
  },

  methods: {

    async handleAdd(payload) {
      const response = await BlacklistService.save({
        type: payload.type,
        document: payload.document,
        name: payload.name,
        reason: payload.reason,
        source: payload.source,
        username: this.user.name
      })

      const status = response.status

      if (status === 400) {
        this.$toast.warning('Verifique os dados inseridos')
        return
      }

      if (status === 422) {
        this.$toast.warning('Esse cliente já está na blacklist')
        return
      }

      await this.fetchBlacklist()
      this.showAddModal = false

      this.$toast.success('Cliente adicionado com sucesso')
    },

    async handleBulkUpload(file) {
    try {
      this.bulkLoading = true 

      const response = await BlacklistService.saveByFile(
        file,
        this.user.name 
      )

      const status = response.status

      if (status === 400) {
        this.$toast.error('Erro no arquivo. Verifique o modelo.')
        return
      }

      if (status === 422) {
        this.$toast.warning('Arquivo contém dados inválidos')
        return
      }

        this.bulkResult = response.data
        this.showBulkResultModal = true

        await this.fetchBlacklist()

        this.$toast.success('Arquivo processado com sucesso')

      } catch (error) {
        console.error(error)
        this.$toast.error('Erro ao processar arquivo')
      } finally {
        this.bulkLoading = false
      }
    },

    async handleDelete(data) {
      const response = await BlacklistService.inactivate({
        document: data.document.replace(/\D/g, ''), 
        reason: data.reason,
        username: this.user.name
      })

      const status = response.status

      if (status === 422) {
        this.$toast.warning('Esse cliente já está inativo na Blacklist')
        return
      }

      if (status === 404) {
        this.$toast.error('Registro não encontrado na Blacklist!')
        return
      }

      await this.fetchBlacklist()
      this.showDeleteModal = false
      this.$toast.success('Cliente inativado com sucesso!')
    },
    
    async fetchBlacklist() {
      this.isLoading = true

      try {
        const response = await BlacklistService.getAll()

        const result = response.data.data

        this.header = result.header
        this.history = result.data

      } catch (error) {
        console.error('Erro ao buscar blacklist:', error)
      } finally {
        this.isLoading = false
      }
    }, 

    async handleSearch() {
      const query = this.search.trim()

      if (query.length < 3) {
        this.$toast.warning('Informe ao menos 3 caracteres para realizar a busca')
        return
      }

      try {
        this.searchLoading = true

        const response = await BlacklistService.getByFilter(query)

        if (response.status === 204) {
          this.blacklistResult = []
          this.notFound = true
        } else {
          this.blacklistResult = response.data || []
          this.notFound = false
        }

        this.showResultModal = true
        this.search = ''

      } catch (error) {
        console.error('Erro real:', error)
      } finally {
        this.searchLoading = false
      }
    }, 
    openManual() {
    window.open('https://wiki.viainvest.com.br/index.php/Manual_Blacklist', '_blank')
  }

  }
}
</script>